import { FunctionComponent, useState } from "react";
import { useTranslation } from "react-i18next";
import { Switch, Typography } from "@mui/material";

import {
	useGenerateTwoFactorCodeMutation,
	useUpdateMeMutation,
} from "@/pages/Private/redux/account/account.api";

import { Enable2FAModal } from "./Enable2FAModal";

export const ProfileSecurity: FunctionComponent<{
	is2FAEnabled: boolean;
	isEmailOtpEnabled: boolean;
}> = ({ is2FAEnabled, isEmailOtpEnabled }) => {
	const { t } = useTranslation();
	const ts = (key: string) => t(`account.${key}`);

	const [generate, { data: qrCode, isLoading }] = useGenerateTwoFactorCodeMutation();

	const [updateMe, { isLoading: isUpdateLoading }] = useUpdateMeMutation();

	const [is2FAEnableModalOpen, setIs2FAEnableModalOpen] = useState<boolean>(false);

	const handle2FactAuthChange = async () => {
		setIs2FAEnableModalOpen(true);

		if (!is2FAEnabled) {
			await generate();
		}
	};
	const handleEmailOtpChange = async () => {
		await updateMe({ isEmailOtpEnabled: !isEmailOtpEnabled }).unwrap();
	};

	return (
		<>
			<div className="max-w-[640px] mx-8 pt-6 pb-4 px-6 bg-surface border rounded-xl border-border shadow-[0_1px_2px_0_rgba(16,24,40,0.05)]">
				{" "}
				<Typography
					sx={{
						color: "text.primary",
						fontWeight: 500,
					}}
					variant="body2"
				>
					{ts("profileSecurity")}
				</Typography>
				<div className="flex flex-col justify-between items-center  px-2 py-3 rounded-lg  mb-5 mt-3 gap-2">
					<div className="flex justify-between flex-row w-full items-center bg-white px-2 py-1 rounded-xl border border-gray-200">
						<div className="">
							<Typography
								sx={{
									color: "text.secondary",
									fontWeight: 500,
									mb: 0.5,
								}}
								variant="body2"
							>
								{ts("profileSecurityDescription")}
							</Typography>
						</div>

						<Switch
							checked={is2FAEnabled}
							color="primary"
							size="medium"
							onChange={handle2FactAuthChange}
						/>
					</div>
					<div className="flex justify-between flex-row w-full items-center bg-white px-2 py-1 rounded-xl border border-gray-200">
						<div className="">
							<Typography
								sx={{
									color: "text.secondary",
									fontWeight: 500,
									mb: 0.5,
								}}
								variant="body2"
							>
								{ts("emailOtpDescription")}
							</Typography>
						</div>

						<Switch
							checked={isEmailOtpEnabled}
							color="primary"
							size="medium"
							onChange={handleEmailOtpChange}
						/>
					</div>
				</div>
				{is2FAEnableModalOpen && (
					<Enable2FAModal
						isLoading={isLoading}
						isOpen={is2FAEnableModalOpen}
						isRegistration={false}
						qrCode={is2FAEnabled ? "" : (qrCode as string)}
						setIsOpen={setIs2FAEnableModalOpen}
					/>
				)}
			</div>
		</>
	);
};
